module.exports = {
      id: "google-usage",
      viewBox: "0 0 533.5 544.3",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#google",
      toString: function () {
        return this.url;
      }
    }